import React, { Fragment } from 'react';
import { capitalize } from '../../../utils/Helpers';
import makeAnimated from 'react-select/animated';
import Select from 'react-select';
import FormError from '../../_shared/forms/FormError';

const animatedComponents = makeAnimated();

const FormMultiSelect = (props) => {
    const { label, options, handleMultiSelectChange, prefixes, error, action } = props;

    const customStyles = {
        control: (provided) => ({
            ...provided,
            border: error ? '1px solid red' : provided.border,
        }),
    };
    return (
        <Fragment>
            <label>{label}</label>
            <Select
                components={animatedComponents}
                options={options}
                onChange={(value) => handleMultiSelectChange(value)}
                styles={customStyles}
                defaultValue={prefixes}
                value={prefixes}
                isMulti
            />
            {error && <small className="text-danger">{error}</small>}
        </Fragment>
    );
};

const SearchableSelect = (props) => {
    let { classes, value, isSearchable, options, name, label, handleChange, isClearable, error } = props;
    let customStyles = {
        control: (provided) => ({
            ...provided,
            border: error ? '1px solid red' : provided.border,
        }),
    };

    let defaultValue, mappedOptions;
    if (options) {
        mappedOptions = options.map((opt) => {
            return { value: opt.id, label: opt.name, disabled: opt.disabled };
        });
        defaultValue = mappedOptions.find((opt) => {
            return opt.value === value.id;
        });
    }
    return (
        <Fragment>
            <label>{label}</label>
            <Select
                className={classes}
                classNamePrefix="select"
                isClearable={isClearable || false}
                isSearchable={isSearchable}
                name={name}
                styles={customStyles}
                onChange={(e) => handleChange(e, name)}
                options={mappedOptions}
                defaultValue={defaultValue}
                value={defaultValue}
                isOptionDisabled={(option) => option.disabled === 'yes'}
            />
            <FormError error={error || ''} class={'d-block'} />
        </Fragment>
    );
};

export { FormMultiSelect as default, SearchableSelect as SearchableSelect };
